// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-c89b7738] .order-placed-modal{max-width:400px;overflow:hidden}.image[data-v-c89b7738]{align-items:center;display:flex;justify-content:center}.image img[data-v-c89b7738]{max-height:224px;width:auto}.notice[data-v-c89b7738]{line-height:1.5em;margin:1em 0}.toggler[data-v-c89b7738]{margin-top:1em;text-align:left;width:100%}.toggler[data-v-c89b7738] .el-checkbox__label{font-size:12px}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
